import { render, staticRenderFns } from "./ClientActionsDropdown.vue?vue&type=template&id=7893e637"
import script from "./ClientActionsDropdown.vue?vue&type=script&lang=js"
export * from "./ClientActionsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports